<template>
  <div class="video-mon">
    <div class="video-top">
      <span class="top-left">视频监控</span>
      <div class="top-right">
        <el-select
          clearable
          v-model="province_value"
          placeholder="请选择省份"
          @change="getcitys(province_value)"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.province"
            :label="item.province"
            :value="item.province"
          ></el-option>
        </el-select>
        <el-select
          v-model="cityName"
          clearable
          placeholder="请选择城市"
          @change="getStations(cityName)"
        >
          <el-option
            v-for="item in cityList"
            :key="item.city"
            :label="item.city"
            :value="item.city"
          ></el-option>
        </el-select>
        <el-select
          v-model="stationName"
          clearable
          placeholder="请选择场站"
          @change="stationChange"
        >
          <el-option
            v-for="item in stationList"
            :key="item.station_id"
            :label="item.station_name"
            :value="item.station_id"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="video-content">
      <el-row :gutter="15">
        <el-col
          v-for="items in videoList"
          :key="items.camera_id"
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
        >
          <video
            :id="items.camera_id"
            @click="videoplay(items.camera_id)"
            class="grid-content bg-purple video-js vjs-default-skin"
            controls
            progressControl="true"
            playsinline
            webkit-playsinline
            poster="../../assets/img/video1.jpg"
            autoplay
          >
            <source :src="items.video_link" type="application/x-mpegURL" />
          </video>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { videkit } from "../../assets/js/ezuikit.js";
import Vue from "vue";
import { constants } from "fs";
export default {
  data() {
    return {
      screenWidth: "",
      playerArr: [],
      // province_value:this.$store.state.emProvinces,
      province_value: "", //选择省份
      provinceList: [], //省份列表
      cityList: [],
      stationList: [],
      videoList: [],
      // cityName:this.$store.state.emCity,
      // stationName:this.$store.state.emStation,
      cityName: "",
      stationName: "",
      stationId: "",
    };
  },
  mounted() {
    document.getElementsByTagName("body")[0].className = "video-body";
    this.$nextTick(function () {
      this.getprovinces();
      this.getVideos(this.$store.state.emStation);
    });
  },
  beforeCreate() {
    // document.getElementsByTagName("body")[0].className="video-body";
  },
  beforeDestroy() {
    document.body.removeAttribute("class", "video-body");
    // console.log("组件即将被销毁")
    for (let i = 0; i < this.playerArr.length; i++) {
      this.playerArr[i].stop();
      let obj = this.playerArr[i];
      if (obj.isDelete) {
        this.playerArr.splice(i, 1);
        i--;
      }
    }
  },
  // watch:{
  //   this.$store.state.emStation:function(){}
  // },
  methods: {
    videoplay(id) {
      // console.log(id);

      var player = new EZUIPlayer(id);
      player.on("error", function() {
        // console.log('————error');
      });
      player.on("play", function() {
        // console.log('--play');
      });
      player.on("pause", function() {
        // console.log('++pause');
      });
      this.playerArr.push(player);
    },

    /**
     * 获取省份数据列表
     */
    getprovinces() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      // console.log("省份传参--：", params);
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_provinces",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.provinceList = su.data.list;
            // this.province_value = this.$store.state.videoProvince?this.$store.state.videoProvince:this.provinceList[0].province;
            // this.getcitys2(this.$store.state.videoProvince?this.$store.state.videoProvince:this.provinceList[0].province);
            this.province_value = this.$store.state.emProvinces
              ? this.$store.state.emProvinces
              : this.provincesList[0].province;
            this.getcitys2(
              this.$store.state.emProvinces
                ? this.$store.state.emProvinces
                : this.provincesList[0].province
            );
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },

    /**
     * 获取城市列表
     */
    getcitys(province_value) {
      this.stationList = [];
      this.cityName = "";
      this.stationName = "";

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province: province_value,
      };

      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.cityList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },

    getcitys2(province_value) {
      this.cityList = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province: province_value,
      };

      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.cityList = su.data.list;
            // this.cityName = this.$store.state.videoCity?this.$store.state.videoCity:this.cityList[0].city;
            this.cityName = this.$store.state.emCity
              ? this.$store.state.emCity
              : this.cityList[0].city;
            if (this.cityName == "信阳") {
              this.cityName = "信阳市";
            }
            // if(this.$store.state.videoCity == "信阳"){
            //   this.$store.state.videoCity = "信阳市";
            // }
            // this.getStations2(this.$store.state.videoCity?this.$store.state.videoCity:this.cityList[0].city);

            if (this.$store.state.emCity == "信阳") {
              this.$store.state.emCity = "信阳市";
            }
            this.getStations2(
              this.$store.state.emCity
                ? this.$store.state.emCity
                : this.cityList[0].city
            );
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getStations(city) {
      this.stationName = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city: city,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          // console.log("充电记录场站列表--:",su)
          if (su.data.code == 1) {
            this.stationList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },

    getStations2(city) {
      // this.stationName = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city: city,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          // if (su.data.code == 1) {
          //   this.stationList = su.data.list;
          //   this.stationName = this.$store.state.videoStation?this.$store.state.videoStation:this.stationList[0].station_name;
          //   this.stationId = this.$store.state.videoStation?this.$store.state.videoStation:this.stationList[0].station_id;
          //   this.getVideos(this.stationId);
          // } else if (su.data.code == 0) {
          //   this.$message.warning(su.data.message);
          // } else if (su.data.code == 300) {
          //   this.$router.push("/login");
          //   this.$message.warning(su.data.message);
          // }

          if (su.data.code == 1) {
            this.stationList = su.data.list;
            this.stationName = this.$store.state.emStation
              ? this.$store.state.emStation
              : this.stationList[0].station_name;
            this.stationId = this.$store.state.emStation
              ? this.$store.state.emStation
              : this.stationList[0].station_id;
            this.getChargerGunCount2(
              this.$store.state.emStation
                ? this.$store.state.emStation
                : this.stationList[0].station_id
            );
            this.getDeviceList2(
              this.$store.state.emStation
                ? this.$store.state.emStation
                : this.stationList[0].station_id
            );
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },

    stationChange(data) {
      for (let i = 0; i < this.playerArr.length; i++) {
        this.playerArr[i].stop();
        let obj = this.playerArr[i];
        if (obj.isDelete) {
          this.playerArr.splice(i, 1);
          i--;
        }
      }

      this.playerArr = [];

      this.videoList = [];
      this.stationId = data;
      this.getVideos(data);

      // this.$store.commit("changevideoProvinces",this.province_value);
      // this.$store.commit("changevideoCity",this.cityName);
      // this.$store.commit("changevideoStation",this.stationId);

      this.$store.commit("changeEmProvinces", this.province_value);
      this.$store.commit("changeEmCity", this.cityName);
      this.$store.commit("changeEmStation", this.stationId);
    },
    getVideos(data) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getVideos",
        station_id: data,
      };
      this.$api({
        method: "post",
        url: "/api.php/CameraMonitor/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            let datalist = su.data.list;
            var timestamp = new Date().getTime(); //毫秒
            for (var i = 0; i < datalist.length; i++) {
              datalist[i].camera_id = datalist[i].camera_id + timestamp;
            }
            // console.log("新的datalist--",datalist)

            this.videoList = datalist;
            console.log(datalist);
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped lang="scss">
.video-mon {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  -o-user-select: none;
  user-select: none;
  .video-top {
    width: 98%;
    margin-left: 1%;
    height: 62px;
    background-color: #0c202b;
    margin-top: 18px;
    .top-left {
      color: #feffff;
      float: left;
      line-height: 62px;
      margin-left: 20px;
    }
    .top-right {
      float: right;
      margin-right: 20px;
      margin-top: 11px;
    }
  }
  .video-content {
    margin-top: 1.2%;
    margin-left: 1%;
    margin-right: 1%;

    video {
      width: 100%;
    }

    .el-col {
      border-radius: 4px;
    }
    .bg-purple-dark {
      // background: #99a9bf;
    }
    .bg-purple {
      // background: #d3dce6;
    }
    .bg-purple-light {
      background: #e5e9f2;
    }
    .grid-content {
      // height: 200px;
      margin-bottom: 10px;
      border-radius: 4px;
      min-height: 36px;
    }
    // ul {
    //   width: 100%;
    //   margin-left: 1%;
    //   list-style: none;
    //   li {
    //     width: 24.5%;
    //     margin-right: 1%;
    //     height: 380px;
    //     background-color: #122430;
    //   }
    //   li:nth-child(4n+4) {
    //     margin-right: 0px;
    //   }
    // }
  }
}
</style>
<style lang="scss">
.video-mon {
  .top-right {
    .el-select {
      ::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #58b6ea !important;
      }
      :-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #58b6ea !important;
      }
      ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #58b6ea !important;
      }
      :-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #58b6ea !important;
      }
      .el-input__inner {
        border: 1px solid #60c8ff !important;
        background-color: transparent !important;
        color: #58b6ea !important;
      }
      .el-input {
        .el-select__caret {
          color: #58b6ea !important;
        }
      }
    }
  }
}
.video-body .el-select-dropdown {
  border: 1px solid #135a69 !important;
  background-color: #132b39 !important;
  ul {
    li {
      span {
        color: #58b6ea !important;
      }
    }
    li:hover {
      background-color: #317dd6 !important;
      span {
        color: #fff !important;
      }
    }
  }
  .popper__arrow {
    display: none !important;
  }
}
.el-popper {
  margin-top: 0 !important;
}
.video-body .el-select-dropdown__item.hover,
.video-body .el-select-dropdown__item:hover {
  background-color: #317dd6 !important;
  span {
    color: #fff !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/realTimeMonitoring/videoMonitoring.vue